
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/notice/[postId]",
      function () {
        return require("private-next-pages/festivals/[festivalId]/notice/[postId].tsx");
      }
    ]);
  